import type { FC } from 'react';

import { Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { FormattedMessage, useIntl } from 'shared/components/Intl';
import { InfoTooltip } from 'shared/components/InfoTooltip';
import { useSidebarContext } from 'shared/providers/Sidebar';
import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';

import { Wrapper } from './Wrapper.styled';

export const MasqueradingFooter: FC = () => {
  const { isOpen } = useSidebarContext();
  const { formatMessage } = useIntl();
  const { isCurrentAccountObserver } = useAccessibleAccounts();

  if (!isCurrentAccountObserver) {
    return null;
  }

  return (
    <Wrapper isOpen={isOpen}>
      <Typography color='inherit'>
        <FormattedMessage id='masqueradingFooter.title' />
      </Typography>
      <InfoTooltip title={formatMessage({ id: 'masqueradingFooter.tooltip' })}>
        <InfoOutlinedIcon color='inherit' />
      </InfoTooltip>
    </Wrapper>
  );
};
